import React, { useState } from 'react';
import { Container, Title, Text, Button, Group, Stack, Textarea, Alert } from '@mantine/core';
import { IconArrowLeft, IconDownload, IconInfoCircle } from '@tabler/icons-react';
import { EXAMPLE_PLAN_YAML } from '../utils/planSchema';

function PlanEditor({ onBack }) {
  const [yaml, setYaml] = useState(EXAMPLE_PLAN_YAML);

  const handleDownload = () => {
    const blob = new Blob([yaml], { type: 'text/yaml' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'test-plan.yaml';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Container size="lg" py="lg">
      <Group justify="space-between" mb="md">
        <Button variant="subtle" leftSection={<IconArrowLeft size={16} />} onClick={onBack}>
          Back to Plans
        </Button>
        <Button
          color="violet"
          leftSection={<IconDownload size={16} />}
          onClick={handleDownload}
        >
          Download YAML
        </Button>
      </Group>

      <Stack gap="md">
        <Title order={2}>Test Plan Editor</Title>
        <Alert color="violet" icon={<IconInfoCircle size={16} />}>
          A Monaco-based editor with live JSON-Schema validation (Ajv) is planned.
          For the scaffold, this is a plain textarea seeded with the example plan;
          validation happens server-side at run-submit time.
        </Alert>

        <Textarea
          value={yaml}
          onChange={(e) => setYaml(e.currentTarget.value)}
          minRows={24}
          autosize
          styles={{ input: { fontFamily: 'ui-monospace, SFMono-Regular, monospace', fontSize: 13 } }}
        />

        <Text size="sm" color="dimmed">
          See <code>src/platforms/sit/utils/planSchema.js</code> for the v1 JSON Schema.
        </Text>
      </Stack>
    </Container>
  );
}

export default PlanEditor;
